export const ENERGY_CERTIFICATION_LABEL_SIZES = {
  small: 'small',
  large: 'large'
};
